import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums-admin",
  "use": "icon-ums-admin-usage",
  "viewBox": "0 0 34.591 34.591",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.591 34.591\" id=\"icon-ums-admin\">\n  <path id=\"icon-ums-admin_路径_2977\" data-name=\"路径 2977\" d=\"M33.6,6.367,17.481,13.075,1.327,6.367,17.444,0ZM16.078,16.013V34.591L12.1,32.782q-4.236-1.877-8.482-3.731a5.594,5.594,0,0,1-1.475-1A7.363,7.363,0,0,1,1,26.7a6.261,6.261,0,0,1-.736-1.564A5.428,5.428,0,0,1,0,23.512V9.157l16.08,6.856ZM34.591,9.157V23.438a5.064,5.064,0,0,1-.371,1.9,8.491,8.491,0,0,1-2.211,3.165,6.617,6.617,0,0,1-1.364.964L26.551,31.2q-2.138.9-3.946,1.66-2.1.9-4.129,1.732V16.013Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums-admin.svg
// module id = FR/6
// module chunks = 19